<template>
  <div class="content">
    <iframe ref="mainIframe" style="height: 100%;width: 100%;" src="/webgl-more/index.html" frameborder="0"></iframe>
  </div>
</template>

<script>
  import util from '../../untils/util'
  import myHttp from '../../untils/port'
  export default {
    data() {
      return {
        projectId: '',
        list: [],
      }
    },

    created() {
      this.projectId = util.session.get('groupId')
      this.getTowerList()
    },

    mounted() {
      const mapFrame = this.$refs.mainIframe
      let that = this
      if(mapFrame.attachEvent){
        mapFrame.attachEvent('onload', function(){
          const iframeWin = mapFrame.contentWindow
          const data ={
            projectId: that.projectId,
            towerList: that.list
          }
          iframeWin.postMessage(data)
        })
      }else{
        mapFrame.onload = function(){
          const iframeWin = mapFrame.contentWindow
          const data ={
            projectId: that.projectId,
            towerList: that.list
          }
          iframeWin.postMessage(data)
        }
      }
    },

    methods: {
      getTowerList(){
        myHttp.getTowerListByPage({
          projectId: this.projectId
        }).then(res => {
          if(res.data.code === 200){
            const towerList = res.data.data.towerList
            let data = []
            towerList.forEach(item => {
              let obj = []
              obj[0] = item.name
              data.push(obj)
            })
            this.list = data
            console.log(data);
          }
        })
      },
    },
  }
</script>

<style scoped>
.content {
  height: 100%;
}
</style>